import Facade from '../Facade'

export class RestoreUtil {
    public static readonly MUSIC_KEY = 'music'
    public static readonly SOUND_KEY = 'sound'
    public static readonly VOLUME_KEY = 'volume'
    public static readonly SKIP_INTRO_KEY = 'skipIntro'
    public static readonly SPACEBAR_SPIN_KEY = 'spacebarSpin'
    public static readonly TURBO_SPIN_KEY = 'turboSpin'

    /** Prefer URL username (play-for-fun / QA), then player_uid. */
    public static getUserStorageId = (): string => {
        try {
            const params = new URLSearchParams(window.location.search)
            const username = params.get('username')?.trim()
            if (username) return username
            const playerUidParam = params.get('player_uid')?.trim()
            if (playerUidParam) return playerUidParam
        } catch {
            // ignore
        }
        return String(Facade.urlParams?.playerUid || 'anonymous')
    }

    public static getKeyData = (key: string): any => {
        return JSON.parse(localStorage.getItem(RestoreUtil.getUserStorageId() + key))
    }

    public static setKeyData = (key: string, data: string) => {
        localStorage.setItem(RestoreUtil.getUserStorageId() + key, data)
    }
}
